import './Navbar.css';
import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Grow from '@mui/material/Grow';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

function Navbar() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className='navbar anchor_tags' id="home">
      <Grow in={true}>
        <a href="#home" aria-label="Inicio">Logo</a>
      </Grow>
      <Grow in={true} className='desktop'>
          <ul>
              <li><a href='#sobremi'>Sobre mi</a></li>
              <li><a href='#servicios'>Servicios</a></li>
              <li><a href='#contacto'>Contacto</a></li>
          </ul>
      </Grow>
      <Grow in={true} className='mobile'>
        <div>
          <IconButton
            aria-label="more"
            id="long-button"
            aria-controls={open ? 'long-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            slotProps={{
              list: {
                'aria-labelledby': 'basic-button',
              },
            }}
          >
            <MenuItem onClick={handleClose}><a href='#sobremi'>Sobre mi</a></MenuItem>
            <MenuItem onClick={handleClose}><a href='#servicios'>Servicios</a></MenuItem>
            <MenuItem onClick={handleClose}><a href='#contacto'>Contacto</a></MenuItem>
          </Menu>
        </div>
      </Grow>
    </div>

  );
}

export default Navbar;